
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AddressData {
  addressline1: string;
  addressline2: string;
  addressline3: string;
  city: string;
  selectedState: any;
  selectedCountry: any;
  selectedCountryName: any;
  selectedStateName: any;
  zipcode: string;
}

interface CompanyData {
  companyname: string;
  companyregistationnumber: string;
  companylogourl: string;
  website: string;
}

interface FormData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  altPhone: string;
  numberofusers: string;
  selectedBillingCurrency: any;
  timeZone: string;
  password: string;
  isdemoaccount: boolean;
}

interface FormState {
  clientUserData: Partial<FormData>;
  companyData: Partial<CompanyData>;
  addressData: Partial<AddressData>;
}

const initialState: FormState = {
  clientUserData: {},
  companyData: {},
  addressData: {},
};

export const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    setClientUserData: (state, action: PayloadAction<Partial<FormData>>) => {
      state.clientUserData = { ...state.clientUserData, ...action.payload };
    },
    setCompanyData: (state, action: PayloadAction<Partial<CompanyData>>) => {
      state.companyData = { ...state.companyData, ...action.payload };
    },
    setAddressData: (state, action: PayloadAction<Partial<AddressData>>) => {
      state.addressData = { ...state.addressData, ...action.payload };
    },
    clearFormData: (state) => {
      state.clientUserData = {};
      state.companyData = {};
      state.addressData = {};
    },
  },
});

export const { setClientUserData, setCompanyData, setAddressData, clearFormData } = formSlice.actions;
export default formSlice.reducer;